import VacanciesList from '@/orm/models/VacanciesList/VacanciesList';
import { computed } from '@vue/composition-api';
import VacanciesListVacancies from '@/orm/models/VacanciesList/VacanciesListVacancies';
import Address from '@/orm/models/Address/Address';
import api from '@/api';

export default function useVacanciesList() {
  const vacancyLists = computed(() => VacanciesList.all());
  const addresses = computed(() => Address.all());
  const metaData = computed(() => VacanciesList.getMetaData());
  const metaDataVacancies = computed(() => VacanciesListVacancies.getMetaData());

  async function fetchAll(page, perPage) {
    await VacanciesList.deleteAll();
    await VacanciesList.api().index({ page, perPage });
  }

  function store(payload) {
    return VacanciesList.api().store(payload);
  }

  async function fetchVacancies(payload) {
    await VacanciesListVacancies.deleteAll();
    return VacanciesListVacancies.api().index(payload);
  }

  async function fetchAddresses() {
    await Address.deleteAll();
    return Address.api().fetchCompanyAddresses();
  }

  function fetchById(id) {
    return VacanciesList.api().show(id);
  }

  function findById(id) {
    return VacanciesList.find(id);
  }

  function update(id, payload) {
    return VacanciesList.api().update({ id, payload });
  }

  function destroy(id) {
    return VacanciesList.api().destroy(id);
  }

  async function getNoActiveState() {
    const result = await api.get('vacancy_lists/not_active_exists');
    return result.data?.notActiveExists;
  }

  const vacancies = computed(() => VacanciesListVacancies.all());

  return {
    vacancyLists,
    metaData,
    metaDataVacancies,
    fetchAll,
    store,
    fetchVacancies,
    vacancies,
    fetchById,
    update,
    findById,
    destroy,
    getNoActiveState,
    addresses,
    fetchAddresses,
  };
}
